import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=12372f5c&scoped=true&"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts&"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=12372f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12372f5c",
  null
  
)

export default component.exports